import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=f9323752&scoped=true"
import script from "./dataStatistics.vue?vue&type=script&lang=js"
export * from "./dataStatistics.vue?vue&type=script&lang=js"
import style0 from "./dataStatistics.vue?vue&type=style&index=0&id=f9323752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9323752",
  null
  
)

export default component.exports